import React, { useState } from "react";
import { Badge, Card, Col, ListGroup, Row } from "react-bootstrap";
import { BsFillBuildingsFill, BsFillDeviceSsdFill } from "react-icons/bs";
import { FaBackward, FaForward, FaFileInvoice, FaQuestion, FaFileInvoiceDollar } from "react-icons/fa";
import { MdEnergySavingsLeaf } from "react-icons/md";
import { TbCoins, TbZzz, TbZzzOff } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../context/AuthContext";
import { BiSupport } from "react-icons/bi";


/**
 * ElvDetailsCard
 * 
 * Card to display extended information about single 
 * Energieliefervertrag.
 * 
 * Used in: ElvDetailPage.jsx
 * 
 * @param {props} leerstandModal setter for model (on/off)
 * @param {props} teilvorschreibungModal setter for modal (on/off)
 * @param {props} elv object Energieliefervertrag
 * @param {props} pastElv integer id of previous elv
 * @param {props} energyProduct object Energieprodukt
 * @param {props} tickets list of ticket objects
 */
const ElvDetailsCard = (props) => {

    // props passed from parent
    const elv = props.elv;
    const pastElv = props.pastElv;
    const product = props.energyProduct;

    const { user } = useAuthState();
    const navigate = useNavigate();
    // if true displays energy product information under 3 elv colums
    const [showProductDetails, setShowProductDetails] = useState(false);
    const [showTickets, setShowTickets] = useState(false);


    // download base64
    const download_base64 = (e) => {
        e.preventDefault();
        var linksource = `data:application/pdf;base64,${product.x_file_preisblatt}`;
        var fileName = product.x_file_preisblatt_name;
        const downloadLink = document.createElement('a');
        downloadLink.href = linksource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    // navigate to support passing this elv as object
    const supportHandler = () => {
        if (user.x_is_house_management)
            navigate('/hw/dashboard/support/neu/elv', {state: {object:elv}})
        else 
            navigate('/dashboard/support/neu/elv', {state: {object:elv}})
    }

    // GUI
    return (
        <>
            {elv.x_futureelv_id.length > 0 || pastElv !== false?
                <Row className="mb-3">
                    <Col xs="6" className="text-start" hidden={pastElv === false} >
                        <a 
                            href={`/${user.x_is_house_management? 'hw/':""}dashboard/energieliefervertraege/${pastElv}`} 
                            className="link-energo"
                            >
                                <FaBackward 
                                    style={{marginLeft: "10px"}}
                                    size={30}
                                /> 
                                <span style={{marginLeft: "10px"}}>Vorheriger Energieliefervertrag</span>
                            </a>
                    </Col>
                    <Col xs={pastElv === false? "12": "6"} className="text-end" hidden={elv.x_futureelv_id.length === 0} >
                        <a 
                            href={`/${user.x_is_house_management? 'hw/':""}dashboard/energieliefervertraege/${elv.x_futureelv_id[0]}`} 
                            className="link-energo"
                        >
                            <span style={{marginRight: "10px"}}>Nächster Energieliefervertrag</span>
                            <FaForward size={30} style={{marginRight: "10px"}}/>
                        </a>
                    </Col>
                </Row>
            : null
            }
            <Card className="shadow-lg" style={{borderRadius: "20px", borderBottom: "3px solid #a2c13f"}}>
                <Card.Body>
                    <Row className="mt-3">
                        <Col xs="12" md="4" xl="4" className="border-right" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark" style={{marginBottom: "35px"}}><FaFileInvoice size={30} />&nbsp; Energieliefervertrag</h5>
                            <p>
                                <small className="text-muted">
                                    Belieferungsbeginn &nbsp;
                                </small> 
                                {elv.x_belbeg !== 'False' ? new Date(elv.x_belbeg).toLocaleDateString('DE-de') : "TBA"}
                            </p>
                            <p>
                                <small className="text-muted">Vertragsende &nbsp;</small>
                                {elv.x_datum_vertragsende !== 'False' ? new Date(elv.x_datum_vertragsende).toLocaleDateString('DE-de') : 'offenes Vertragsende'}
                            </p>
                            {Number(elv.x_teilvorschreibung_brutto) !== 0 ?
                                <p>
                                    <small className="text-muted">Teilvorschreibung brutto &nbsp;</small>
                                    {Number(elv.x_teilvorschreibung_brutto).toFixed(2)} €
                                </p>
                                :
                                null
                            }
                            <p>
                                <a href="details/" onClick={e => {e.preventDefault(); setShowProductDetails(!showProductDetails)}} className="link-energo">
                                    {showProductDetails? 'Energieprodukt ausblenden':'Energieprodukt anzeigen'}
                                </a>
                            </p>
                            {props.tickets && props.tickets.length > 0?
                                <p>
                                    <a href="tickets/" onClick={e => {e.preventDefault(); setShowTickets(!showTickets)}} className="link-energo">
                                        {showTickets ? 'Support-Tickets ausblenden':'Support-Tickets anzeigen'}
                                    </a>
                                </p>
                            :null}
                        </Col>
                        <Col xs="12" md="4" xl="4" className="border-right" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark" style={elv.x_is_leerstand !== true? {marginBottom: "35px"}:null}>
                                <BsFillDeviceSsdFill size="30" />&nbsp; Anlage
                            </h5>
                            {elv.x_is_leerstand ? <TbZzz style={{ position: "relative", top: -65, right: -27 }} /> : null}
                            <p>
                                <small className="text-muted">Anlagennummer ENERGO &nbsp;</small>
                                {elv.x_anlage_id.x_studio_field_mWMGR}
                            </p>
                            <p hidden={elv.x_anlagennummer_lieferant === "False"}>
                                <small className="text-muted">Anlagennummer Energielieferant  &nbsp;</small>
                                {elv.x_anlagennummer_lieferant}
                            </p>
                            <p>
                                <small className="text-muted">Energieform &nbsp;</small>
                                {elv.x_anlage_id.x_studio_field_3eKe0}
                            </p>
                            <p>
                                <small className="text-muted">Zählernummer &nbsp;</small>
                                {elv.x_anlage_id.x_zaehlernummer_01}
                            </p>
                            <p hidden={elv.x_anlage_id.x_zaehlernummer_02 === "" || elv.x_anlage_id.x_zaehlernummer_02 === "False"}>
                                <small className="text-muted">Zählernummer 2 &nbsp;</small>
                                {elv.x_anlage_id.x_zaehlernummer_02}
                            </p>
                            <p hidden={elv.x_verbrauch_alt_nb === 'False' || elv.x_verbrauch_alt_nb === '0'}>
                                <small className="text-muted">Geschätzter Verbrauch &nbsp;</small>
                                {Number(elv.x_verbrauch_alt_nb).toLocaleString('DE-de')} KWh
                            </p>
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}}>
                            <h5 className="text-dark" style={{marginBottom: "35px"}}><BsFillBuildingsFill size={30}/>&nbsp; Rechnungsadresse</h5>
                            <p><small className="text-muted">Straße &nbsp;</small>{elv.x_address_street}</p>
                            <p><small className="text-muted">PLZ &nbsp;</small>{elv.x_address_plz}</p>
                            <p><small className="text-muted">Ort &nbsp;</small>{elv.x_address_city}</p>
                        </Col>
                    </Row>
                    <Row id="productDetailsRow" hidden={!showProductDetails} className="mt-5 border-top animate__animated animate__bounceInDown">
                        <p className="text-energo text-center mt-4 mb-4" style={{paddingLeft: "25px", marginTop: "10px"}}>
                            <MdEnergySavingsLeaf size={30} />&nbsp; Energieprodukt <br />
                            <small>{product.x_name}</small>
                        </p>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}} className="border-right">
                            <p><small className="text-muted">Vertragsart &nbsp;</small>{product.x_vertragsart}</p>
                            <p hidden={product.x_vertragsart !== 'Rahmenvertrag'}><small className="text-muted">Vertragsdauer &nbsp;</small>
                                {`${new Date(product.x_vertragsdauer_von).toLocaleDateString('DE-de')} - ${new Date(product.x_vertragsdauer_bis).toLocaleDateString('DE-de')}`}
                            </p>
                            <p><small className="text-muted">Energielieferant &nbsp;</small>{product.x_energielieferant_id[1]}</p>
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}} className="border-right">
                            <p hidden={product.x_produkteigenschaft === "False"}><small className="text-muted">Produkteigenschaft &nbsp;</small>{product.x_produkteigenschaft}</p>
                            <p hidden={product.x_vertragsbindung === "0" || product.x_vertragsbindung === "False"}><small className="text-muted">Vertragsbindung &nbsp;</small>{product.x_vertragsbindung} Monate</p>
                            
                        </Col>
                        <Col xs="12" md="4" xl="4" style={{paddingLeft: "30px"}}>
                            <p hidden={product.x_preis_kwh === 0}><small className="text-muted">Preis pro kWh &nbsp;</small>{product.x_preis_kwh.toFixed(2)} ct</p>
                            <p hidden={product.x_preis_kwh_rabattiert === 0}><small className="text-muted">Preis pro kWh inkl. Rabatt &nbsp;</small>{product.x_preis_kwh_rabattiert} ct</p>
                            <p hidden={product.x_preis_kwh === 0}><small className="text-muted">Grundgebühr &nbsp;</small>{product.x_preis_grundgeb.toFixed(2)} €</p>
                            <p hidden={product.x_file_preisblatt_name === "False"}>
                                <small className="text-muted">Preisblatt &nbsp;</small>
                                <a onClick={e => download_base64(e)} href="download/" className="link-energo">{product.x_file_preisblatt_name}</a>
                            </p>
                        </Col>
                    </Row>

                    <Row id="ticketDetailsRow" hidden={!showTickets} className="mt-3 border-top animate__animated animate__bounceInDown">
                        <p className="text-warning text-center mt-4 mb-4" style={{paddingLeft: "25px", marginTop: "10px"}}>
                            <BiSupport size={30} />&nbsp; Offene Tickets zu diesem Energieliefervertrag
                        </p>
                        {props.tickets && props.tickets.length > 0?
                            <Col xs="12" md="12" xl="12" style={{paddingLeft: "30px"}}>
                                <ListGroup variant="flush">
                                    {props.tickets.map(ticket => 
                                        <ListGroup.Item action onClick={() => navigate(`${user.x_is_house_management? '/hw':''}/dashboard/support/${ticket.id}`) }>
                                            <small className="text-muted">{new Date(ticket.create_date).toLocaleDateString('DE-de')}</small> &nbsp;
                                            <span className="text-warning">{ticket.name} (#{ticket.id})</span> &nbsp; 
                                            <Badge className="rounded-pill" bg={
                                                ticket.stage_id[1] === "Warten auf Drittpartei" ? "primary" :
                                                ticket.stage_id[1] === "On Hold" ? "warning" : 
                                                ticket.stage_id[1] === "Warten auf Kunde" ? "violet" : 
                                                ticket.stage_id[1] === "Warten auf ENERGO" ? "energo" : "secondary"
                                            }>
                                                {ticket.stage_id[1]}
                                            </Badge> &nbsp;
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Col>
                        :null}
                    </Row>
                </Card.Body>
                <Card.Footer style={{paddingTop: "20px", paddingBottom: "20px"}}>
                    <Row className="justify-content-center text-center">
                        <Col xs="12" md="3" xl="3">
                            <a onClick={e => {e.preventDefault();  props.teilvorschreibungModal(true)}} href="/teilvorschreibung/anpassen/" className="link-energo"><TbCoins /> Teilvorschreibung anpassen</a>
                        </Col>
                        <Col xs="12" md="3" xl="3" hidden={true}>
                            <a onClick={e => {e.preventDefault(); props.leerstandModal(true)}} href="/leerstand/abmelden/" className="link-energo"><TbZzzOff /> Leerstand abmelden</a>
                        </Col>
                        <Col xs="12" md="3" xl="3">
                            <a onClick={e => {e.preventDefault(); supportHandler()}} href="/support/" className="link-energo"><FaQuestion /> Frage zu diesem Vertrag</a>
                        </Col>
                        <Col xs="12" md="3" xl="3">
                            <a onClick={e => {e.preventDefault(); props.setMissingInvoiceModal(true)}} href="/rechnung/fehlt/" className="link-energo"><FaFileInvoiceDollar /> Fehlende Abrechnung</a>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>   
        
        </>
    )
}

export default ElvDetailsCard;